module.exports = __webpack_public_path__ + "img/tpc-20.306db2bb.webp";